import React from 'react';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { IoIosHelpCircleOutline } from 'react-icons/io';

const ConfirmPopOver = (props) => {
	const {
		placement,
		title,
		onConfirm,
		confirmText,
		cancelText,
		triggerElement
	} = props;

	const onCancel = () => document.body.click();

	return (
		<OverlayTrigger
			trigger="click"
			placement={placement || 'auto'}
			rootClose
			overlay={
				<Popover id="popover-basic">
					<Popover.Title as="h3" className="d-flex align-items-center">
						<IoIosHelpCircleOutline className="helpIcon mr-2"/>
						<div>{title}</div>
					</Popover.Title>
					<Popover.Content>
						<div className="d-flex justify-content-center">
							<Button
								className="m-2"
								onClick={onCancel}
								variant="light"
								size="sm" 
							>
								{cancelText}
							</Button>
							<Button
								className="m-2"
								size="sm"
								onClick={onConfirm}
							>
								{confirmText}
							</Button>
						</div>
					</Popover.Content>
				</Popover>
			}
		>
			{triggerElement}
		</OverlayTrigger>
	);
};

export default ConfirmPopOver;
